module.exports = __webpack_public_path__ + "static/resume-3ca58f76f4aef59b051bc2b695a9313f.pdf";